import React from 'react';
import styles from './sectionsLayers.scss';
import { cx, hoc } from '#packages/util';
import { useTranslation } from 'react-i18next';
import type { CompRef } from '@wix/document-services-types';
import {
  type SectionsLayersPanelDispatchProps,
  type SectionsLayersPanelStateProps,
  mapDispatchToProps,
  mapStateToProps,
} from './sectionsLayersPanelMapper';
import {
  useTreeNodesContext,
  type TreeNodesContext,
} from './createNodeProps/nodesContext';
import Node from './node';
import { Divider, TextButton } from '@wix/design-system';
import { outerClick as OuterClick } from '#packages/util';
import { ToolPanelFrame } from '#packages/panels/frames';

export interface SectionsLayersPanelOwnProps {
  treeNodesContext: TreeNodesContext;
  origin: string;
  panelName: string;
  sectionRef: CompRef;
  clickPosition: {
    top: number;
    right: number;
  };
}

interface SectionsLayersPanelProps
  extends SectionsLayersPanelOwnProps,
    SectionsLayersPanelStateProps,
    SectionsLayersPanelDispatchProps {}

const SectionsLayersPanel: React.FC<SectionsLayersPanelProps> = ({
  treeProps,
  panelName,
  panelPosition,
  openLayersPanel,
  close,
  setHoveredSection,
}) => {
  const [translate] = useTranslation();

  return (
    <OuterClick onOuterClick={() => close()}>
      <ToolPanelFrame
        panelName={panelName}
        contentStyle={{
          top: panelPosition.top,
          right: panelPosition.right,
        }}
        contentWrapperClass={styles.sectionLayersPanel}
        removeOverlay={true}
        automationId="sections-layers-panel"
      >
        <div
          className={cx('layers-panel', 'with-wbu-icons')}
          onMouseEnter={() => setHoveredSection()}
        >
          {treeProps.section.hasChildNodes && (
            <>
              <Node key="section" {...treeProps.section} />
              <Divider direction="horizontal" />
              <div className={styles.allLayersButton}>
                <TextButton
                  skin="dark"
                  size="small"
                  weight="thin"
                  onClick={() => openLayersPanel()}
                  dataHook="see-all-layers-button"
                >
                  {translate('section_layers_panel_see_all_cta')}
                </TextButton>
              </div>
            </>
          )}
        </div>
      </ToolPanelFrame>
    </OuterClick>
  );
};

export const SectionsLayersPanelOuter: React.FC<SectionsLayersPanelOwnProps> = (
  props,
) => {
  const nodesContext = useTreeNodesContext();

  return (
    <ConnectedSectionsLayersPanel treeNodesContext={nodesContext} {...props} />
  );
};

const ConnectedSectionsLayersPanel = hoc.connect(
  hoc.STORES.EDITOR_API,
  mapStateToProps,
  mapDispatchToProps,
  undefined,
  false,
)(SectionsLayersPanel);
